export type ContextArtifactKind =
	| 'entity'
	| 'enum'
	| 'domain-file'
	| 'operation'
	| 'application-file'
	| 'domain-test-file'
	| 'test-file'
	| 'event-handler'
	| 'integration-event';

export type ContextArtifactSelection = {
	kind: ContextArtifactKind;
	id: string;
};

const artifactPrefixes: ReadonlyArray<readonly [ContextArtifactKind, string]> = [
	['integration-event', 'integration-event-'],
	['event-handler', 'event-handler-'],
	['application-file', 'app-file-'],
	['domain-test-file', 'domain-test-file-'],
	['test-file', 'operation-test-file-'],
	['domain-file', 'file-'],
	['operation', 'op-'],
	['entity', 'entity-'],
	['enum', 'enum-'],
];

export function getContextArtifactId(selection: ContextArtifactSelection): string {
	const prefix = artifactPrefixes.find(([kind]) => kind === selection.kind)?.[1];
	if (!prefix) {
		return selection.id;
	}
	return `${prefix}${selection.id}`;
}

export function parseContextArtifactId(artifactId: string | null | undefined): ContextArtifactSelection | null {
	if (!artifactId) {
		return null;
	}

	const match = artifactPrefixes.find(([, prefix]) => artifactId.startsWith(prefix));
	if (!match) {
		return null;
	}

	const [kind, prefix] = match;
	const id = artifactId.substring(prefix.length);
	return id ? { kind, id } : null;
}

export function isApplicationArtifact(selection: ContextArtifactSelection | null): boolean {
	return selection
		? ['operation', 'application-file', 'test-file', 'event-handler', 'integration-event'].includes(selection.kind)
		: false;
}

export function getArtifactChatContext(selection: ContextArtifactSelection | null, fileName?: string) {
	if (!selection) {
		return {};
	}

	switch (selection.kind) {
		case 'operation':
			return { operationId: selection.id };
		case 'event-handler':
			return { eventHandlerId: selection.id };
		case 'integration-event':
			return { integrationEventId: selection.id };
		case 'entity':
			return { entityId: selection.id };
		case 'enum':
			return { enumId: selection.id };
		case 'domain-file':
		case 'application-file':
		case 'domain-test-file':
		case 'test-file':
			return { fileId: selection.id, fileName };
		default:
			return {};
	}
}
